import React, { useMemo } from 'react'
import { ScoreDisplayProps } from './ScoreDisplay.types'
import {
  Container,
  ScoreContainer,
  ScoreValue,
  ScoreMax,
  ScoreLabel,
  InfoIcon,
  ProgressBarContainer,
  ProgressBar,
  ProgressFill,
} from './ScoreDisplay.styles'

export const ScoreDisplay: React.FC<ScoreDisplayProps> = ({
  value,
  maxValue,
  label,
  variant = 'default',
  showProgress = false,
  tooltip,
  clickable = false,
  className,
  style,
  onClick,
}) => {
  const percentage = useMemo(() => {
    if (!maxValue || !showProgress) return 0
    return Math.min((value / maxValue) * 100, 100)
  }, [value, maxValue, showProgress])

  const handleClick = () => {
    if (clickable && onClick) {
      onClick()
    }
  }

  return (
    <Container
      $variant={variant}
      $withProgress={showProgress}
      $clickable={clickable}
      onClick={handleClick}
      className={className}
      style={style}
      title={tooltip}
    >
      {showProgress ? (
        <>
          <ProgressBarContainer>
            <ScoreContainer>
              <ScoreValue $variant={variant}>{value}</ScoreValue>
              {maxValue && <ScoreMax>/{maxValue}</ScoreMax>}
            </ScoreContainer>
            <ScoreLabel>
              {label}
              {tooltip && <InfoIcon title={tooltip}>i</InfoIcon>}
            </ScoreLabel>
          </ProgressBarContainer>
          <ProgressBar>
            <ProgressFill $variant={variant} $width={percentage} />
          </ProgressBar>
        </>
      ) : (
        <>
          <ScoreContainer>
            <ScoreValue $variant={variant}>{value}</ScoreValue>
            {maxValue && <ScoreMax>/{maxValue}</ScoreMax>}
          </ScoreContainer>
          <ScoreLabel>
            {label}
            {tooltip && <InfoIcon title={tooltip}>i</InfoIcon>}
          </ScoreLabel>
        </>
      )}
    </Container>
  )
}

ScoreDisplay.displayName = 'ScoreDisplay'
